export const brand = {
  main: {
    orange: '#EB5C0A',
    iris: '#754AFA',
    hibiscus: '#F56675',
    mustard: '#FFC200',
    water: '#00A2AB',
    variations: {
      'lighterOrange-1': '#F78848',
      'lighterOrange-2': '#FDC9AB',
      'lighterOrange-3': '#FEF5F0',
      'darkerOrange-1': '#D04C00',
      'darkerOrange-2': '#893200',
      'darkerOrange-3': '#512300',
      'lighterIris-1': '#A487FF',
      'lighterIris-2': '#D3C7FA',
      'lighterIris-3': '#F4F1FF',
      'darkerIris-1': '#653FDA',
      'darkerIris-2': '#4F3C8A',
      'darkerIris-3': '#3E3559',
      'lighterHibiscus-1': '#FF96A1',
      'lighterHibiscus-2': '#FFD2D7',
      'lighterHibiscus-3': '#FFF4F5',
      'darkerHibiscus-1': '#D7515F',
      'darkerHibiscus-2': '#9B4851',
      'darkerHibiscus-3': '#4B3033',
      'lighterMustard-1': '#FFD95F',
      'lighterMustard-2': '#FCEFC4',
      'lighterMustard-3': '#FCF7E7',
      'darkerMustard-1': '#E5AE23',
      'darkerMustard-2': '#997D34',
      'darkerMustard-3': '#72612B',
      'lighterWater-1': '#41BEC6',
      'lighterWater-2': '#B4E8EB',
      'lighterWater-3': '#E6F6F7',
      'darkerWater-1': '#117F84',
      'darkerWater-2': '#20585B',
      'darkerWater-3': '#133F42',
    },
  },
  pastel: {
    candy: '#FAD8E9',
    egg: '#FFE8BA',
    peach: '#FCD9C5',
    mauve: '#E2DDEF',
    sea: '#BEE2E4',
  },
};

export const neutrals = {
  black: '#000000',
  white: '#FFFFFF',
  neutralGrays: {
    coal: '#131313',
    graphite: '#1E1E1E',
    smoke: '#252525',
    tarmac: '#353535',
    cement: '#4E4E4E',
    ash: '#666666',
    grey: '#8F8F8F',
    aluminium: '#B9B9B9',
    titanium: '#C4C4C4',
    dust: '#E3E3E3',
    snow: '#EEEEEE',
    crystal: '#F5F5F5',
    outerspace: '#2E3D3D',
  },
  coldGrays: {
    space: '#101414',
    eclipse: '#1C1F1F',
    steel: '#222626',
    nail: '#373838',
    frost: '#4B4D4D',
    haze: '#717373',
    cloud: '#939999',
    silver: '#B3BABA',
    marble: '#CDD4D4',
    fog: '#DEE5E5',
    pearl: '#EBF0F0',
    ice: '#F3F7F7',
  },
};

export const alert = {
  variations: {
    lighterAlertBlue: '#6ECCFF',
    darkerAlertBlue: '#0079BA',
    lighterAlertGreen: '#B8FF97',
    darkerAlertGreen: '#45A01B',
    lighterAlertYellow: '#FFDD73',
    darkerAlertYellow: '#D9A500',
    lighterAlertRed: '#FFAA9E',
    darkerAlertRed: '#791607',
  },
  alertBlue: '#00A6FF',
  alertGreen: '#5CCD28',
  alertYellow: '#FFC200',
  alertRed: '#DA280C',
  yellow100: '#FFF6D9',
  red500: '#DA280C',
};

export const social = {
  googlePhotos: '#3C4043',
};

export const shadows = {
  shadowOne: '#4F6162',
};

export const text = {
  color: {
    textPrimary: '#131313',
    textSecondary: '#353535',
    textTertiary: '#4E4E4E',
    interactive: '#007B87',
    inverted: '#FFFFFF',
  },
  secondaryText: '#353535',
};

export const progressColor = {
  background: '#FCF4EC',
  bar: '#F4E1CF',
  checkIcon: '#5CCD28',
};

export const buttons = {
  primary: {
    buttonPrimaryBackgroundDefault: '#007B87',
    buttonPrimaryTextDefault: '#FFFFFF',
    buttonPrimaryIconDefault: '#FFFFFF',
  },
  secondary: {
    buttonSecondaryBackgroundDefault: '#FFFFFF',
    buttonSecondaryStrokeDefault: '#007B87',
    buttonSecondaryIconDefault: '#007B87',
  },
  tertiary: {
    buttonTertiaryIconDefault: '#007B87',
  },
  quaternary: {
    buttonQuaternaryBackgroundDefault: '#F3F7F7',
  },
  ghost: {
    buttonGhostBackgroundDefault: '#FFFFFF',
    buttonGhostTextDefault: '#007B87',
    buttonGhostIconDefault: '#007B87',
  },
};

export const icon = {
  iconPrimary: '#131313',
  iconInteractive: '#007B87',
  iconSuccess: '#3B8619',
  iconColorAlert: '#FFC200',
  iconColorDisabled: '#B9B9B9',
  iconColorInverted: '#FFFFFF',
};

export const background = {
  backgroundColorBrand: '#F3F7F7',
  backgroundColorDefault: '#FFFFFF',
  overlayColorModale: '#1E1E1EB8',
  overlayColorTileSelected: '#FFFFFF52',
};

export const stroke = {
  strokeColorActive: '#007B87',
  strokeColorBrand: '#CDD4D4',
  strokeColorNeutral: '#E3E3E3',
};
